/** Design-token colours (CSS variables only; never hard-coded values). */
export const c = {
  p50: "var(--color-primary-50)",
  p100: "var(--color-primary-100)",
  p200: "var(--color-primary-200)",
  p300: "var(--color-primary-300)",
  p400: "var(--color-primary-400)",
  p500: "var(--color-primary-500)",
  p600: "var(--color-primary-600)",
  p700: "var(--color-primary-700)",
  a50: "var(--color-accent-50)",
  a100: "var(--color-accent-100)",
  a200: "var(--color-accent-200)",
  a300: "var(--color-accent-300)",
  a400: "var(--color-accent-400)",
  a500: "var(--color-accent-500)",
  s50: "var(--color-success-50)",
  s100: "var(--color-success-100)",
  s200: "var(--color-success-200)",
  s300: "var(--color-success-300)",
  s500: "var(--color-success-500)",
  d50: "var(--color-danger-50)",
  d100: "var(--color-danger-100)",
  d200: "var(--color-danger-200)",
  d300: "var(--color-danger-300)",
  d500: "var(--color-danger-500)",
  n0: "var(--color-neutral-0)",
} as const;
